import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { useToast } from "@chakra-ui/react";
import { auth, db, functions } from "connections/firebase";
import { ILoginPayload } from "interfaces/auth";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { getErrorMessage } from "utils";

const useAuth = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const sendRequestAccountDeletion = httpsCallable<{ email: string }>(
    functions,
    "requestAccountDeletion"
  );

  const verifyAccountDeletion = httpsCallable<{ uid: string }>(
    functions,
    "verifyDeleteAccount"
  );

  const login = async ({ email, password }: ILoginPayload) => {
    try {
      const adminRef = collection(db, "admins");
      const q = query(adminRef, where("email", "==", email));
      const snapshot = await getDocs(q);
      if (snapshot.empty) {
        throw new Error("Email tidak terdaftar sebagai admin");
      }

      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (error: any) {
      const msg = getErrorMessage(error);
      throw new Error(msg);
    }
  };

  const logout = async () => {
    try {
      await auth.signOut();
      toast({
        title: "Logout Success",
        description: `You've been logout.`,
        status: "success",
        isClosable: true,
      });
      navigate("/login");
    } catch (error: any) {
      const msg = getErrorMessage(error);
      toast({
        title: "Logout Failed",
        description: msg,
        status: "error",
        isClosable: true,
      });
    }
  };

  const sendPasswordReset = async (email: string) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error: any) {
      const msg = getErrorMessage(error);
      throw new Error(msg);
    }
  };

  return {
    login,
    logout,
    sendPasswordReset,
    sendRequestAccountDeletion,
    verifyAccountDeletion,
  };
};

export default useAuth;
